const TAGS = [
    {
        tag: '数据缺失/错误',
        disabled: false ,
    },{
        tag: '优化建议',
        disabled: false,
    },{
        tag: '程序错误',
        disabled: false,
    },{
        tag: '其他',
        disabled: false,
    }
]
import { App_User } from '@/data/user_info'
export default {
    data() {
        return {
            is_consultant: false,
            tags: TAGS,
        }
    },
    methods: {
        async getConsultantStatus() {
            const { is_consultant } = await App_User.get()
            this.is_consultant = is_consultant
        },
        initTags() {
            if (this.from === 'consultant_task' && this.is_consultant) {
                this.tags = TAGS.map((item) => {
                    return {
                        ...item,
                        disabled: item.tag !== '优化建议'
                    }
                })
            }
        },
    }
}